<script setup>
import data from "./index-content.json";
useHead({
    title: "Custom Software, LMS & Web Application Development Company | WebReinvent",
    meta: [
    { charset: "utf-8" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    { name: "twitter:card", content: "summary" },
    { name: "twitter:site", content: "@weinvent" },
    { name: "twitter:creator", content: "@weinvent" },
    {
      property: "og:title",
      content: "Software Products, Web and Mobile App Development Company",
    },
    {
      property: "og:description",
      content:
        "Learning Management System. Most popular online teaching platforms.",
    },
    { property: "og:image:alt", content: "WebReinvent" },
    { property: "og:type", content: "website" },
    { property: "og:url", content: "https://webreinvent.com" },
    { property: "og:site_name", content: "WebReinvent" },
    { property: "fb:admins", content: "204425406249172" },
    {
      name: "description",
      content:
        "Learning Management System. Most popular online teaching platforms.",
    },
    {
      name: "keywords",
      content:
        "sendgrid, stripe, magento, newsletters, zoom, paypal pro, 2checkout",
    },
    { name: "twitter:title", content: "Case Studies" },
    {
      name: "twitter:description",
      content:
        "Learning Management System. Most popular online teaching platforms.",
    },
  ],
  link: [{ rel: "icon", type: "image/x-icon", href: "/favicon.ico" }],
});

const tab = ref([
  {
    companyIcon: "/images/equetronicIcon.webp",
    projectTitle: "Horse Racecourse<br /> Management",
    image: "/images/equetronicCardImage.webp",
  },
  {
    companyIcon: "/images/synergeyesIcon.webp",
    projectTitle: "Lens Order<br /> Management",
    image: "/images/synergeyesCardImage.webp",
  },
  {
    companyIcon: "/images/toolStationIcon.webp",
    projectTitle: "Multi Vendor<br /> Ecommerce",
    image: "/images/toolStationCardImage.webp",
  },
  {
    companyIcon: "/images/avenueIcon.webp",
    projectTitle: "Live Streaming<br /> Platform",
    image: "/images/avenueCardImage.webp",
  },
  {
    companyIcon: "/images/jewishIcon.webp",
    projectTitle: "Learning<br /> Management System",
    image: "/images/jewishCardImage.webp",
  },
  {
    companyIcon: "/images/jalapenoIcon.webp",
    projectTitle: "Survey Management<br /> Software",
    image: "/images/jalapenoCardImage.webp",
  },
]);

const case_studies = data.case_studies;
</script>
<template>
  <div class="max-w-screen-xl mx-auto px-4 mt-10 max-sm:mt-0 relative">
    <div
      class="absolute max-lg:hidden -top-20 left-[1%] p-px bg-[rgba(73,73,73,0.08)] dark:bg-[rgba(54,12,82,1)] w-[1px] h-full"
    />
    <div
      class="absolute max-lg:hidden -top-20 left-[20%] p-px bg-[rgba(73,73,73,0.08)] dark:bg-[rgba(54,12,82,1)] w-[1px] h-full"
    />
    <div
      class="absolute max-lg:hidden -top-20 left-[38%] p-px bg-[rgba(73,73,73,0.08)] dark:bg-[rgba(54,12,82,1)] w-[1px] h-full"
    />
    <div
      class="absolute max-lg:hidden -top-20 right-[42.5%] p-px bg-[rgba(73,73,73,0.08)] dark:bg-[rgba(54,12,82,1)] w-[1px] h-full"
    />
    <div
      class="absolute max-lg:hidden -top-20 right-[22%] p-px bg-[rgba(73,73,73,0.08)] dark:bg-[rgba(54,12,82,1)] w-[1px] h-full"
    />
    <div
      class="absolute max-lg:hidden -top-20 right-[1%] p-px bg-[rgba(73,73,73,0.08)] dark:bg-[rgba(54,12,82,1)] w-[1px] h-full"
    />
    <span
      class="hidden dark:block size-[1421px] bg-[linear-gradient(180deg,_#47116B_41.7%,_rgba(137,22,212,0))] rounded-full absolute left-[155px] -top-[968px] blur-[250px]"
    />

    <span
      class="dark:hidden w-[1070px] h-[1800px] bg-[#FFF] opacity-50 rounded-full absolute -left-60 -top-20 blur-[200px]"
    />
    <section class="relative z-10">
      <h1 class="mb-2 max-md:mb-4 md:mb-4 max-lg:text-center">
        <WrGradientText
          text="Transforming"
          append-class="pb-0 lg:pb-2 bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_-10.57%,_var(--text-gradient-2)_22.72%)]"
        />
        Ideas into Results
      </h1>
      <p class="text-2xl max-md:text-xl max-lg:text-center">
        insights and resources to boost revenue and scale sales with minimal
        overhead.
      </p>

      <div
        class="grid md:grid-cols-2 lg:grid-cols-3 mt-10 h-full gap-6"
      >
        <WrProjectCard v-for="content in case_studies.imagecardcontent" :key="content.value" :content="content" />
      </div>
    </section>

    <section class="lg:mt-[160px] mt-16 relative z-10">
      <WrResultSection />
    </section>

    <section class="lg:mt-[128px] mt-16 relative z-10">
      <h2 class="text-center">
        <WrGradientText text="Trusted for excellence and efficiency" />
        <p class="text-lg text-[var(--foreground)]">
          Webreinvent is trusted by leading organisations to enhance their
          development and operational efficiency.
        </p>
      </h2>
      <WrTestimonialCardCarousel class="mt-12" />
      <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7"
        >View All</WrButton
      >
    </section>
  </div>
</template>

<style lang="scss" scoped></style>
